'use strict';
/**
 * Snackbar
 *
 * エラーなどの通知を行うための Module です。
 * alertify.js の通知機能を利用して画面左下に通知を出します。
 *
 * - success
 * - info
 * - warning
 * - danger
 * - error (danger のエイリアス)
 *
 * @example
 * success({
     *      title: 'my alert title',
     *      content: 'my alert content'
     * });
 * @params {Object} params
 * @params {String} params.title
 * @params {String} params.content
 */

const _ = require('underscore');
const Alertify = require('alertify.js');
const SnackbarTemplate = require('common/ui/template/snackbar.hbs');

Alertify
    .logPosition('bottom left')
    .maxLogItems(10);


const _notify = function(type, params) {
    // alertify.js で利用可能な type名に変換
    type = {
        success: "success",
        info: "log",
        warning: "log",
        danger: "error",
        error: "error",
        fatalError: "fatalError"
    }[type];

    let message = params;
    if (typeof params === 'object') {
        message = SnackbarTemplate(params);
    }

    if (type == 'fatalError') {
        let alertify = new Alertify();
        alertify.logPosition('bottom right')
            .delay(0)
            .closeLogOnClick(false)
            .error(message);
    } else {
        Alertify[type](message);
    }
};

module.exports = {
    success:    _.partial(_notify, 'success'),
    info:       _.partial(_notify, 'info'),
    warning:    _.partial(_notify, 'warning'),
    danger:     _.partial(_notify, 'danger'),
    error:      _.partial(_notify, 'danger'),
    fatalError: _.partial(_notify, 'fatalError')
};



// WEBPACK FOOTER //
// ./common/util/snackbar.js